import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Sooduskood edukalt rakendatud!

  <span style="color:#85c1dc;">**FI:**</span>
  Alennuskoodi on otettu käyttöön!

  <span style="color:#85c1dc;">**RU:**</span>
  Код скидки успешно применен!
*/
/* @__NO_SIDE_EFFECTS__ */
const m1184 = msg(
  mf`Sooduskood edukalt rakendatud!`,
  mf`Alennuskoodi on otettu käyttöön!`,
  mf`Код скидки успешно применен!`,
)

export { m1184 as 'w.basket.summary.voucher_correct' }